import { DadosCEP, RetAPI } from "./Types";
import { Api } from "./api";

type FormatStyle = | "decimal" | "currency"
export const Funcoes = {

    onlyNumber: (cnpj: string) => {
        return  cnpj.replace(/\D/g, '')
    },
    
    isNumber: (value: string) => {
        return !!+value        
    },
    
    numberFormat: (value: any, style?: FormatStyle, minDecimal?: number, maxDecimal?: number) => {

        if (!style) {
            style = 'decimal';
        }

        if (!minDecimal) {
            minDecimal = 2;
        }

        if (!maxDecimal) {
            maxDecimal = 2;
        }

        const options: any = { style, minimumFractionDigits: minDecimal, maximumFractionDigits: maxDecimal };

        if (style === 'currency') {
            options.currency = 'BRL';
        }

        const formatNumber = new Intl.NumberFormat('pt-BR', options);

        return formatNumber.format(value);
    },

    MaskMoney: (value: string) => {
        const onlyDigits = value.split("").filter(s => /\d/.test(s)).join("").padStart(3, "0");

        let digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);
        digitsFloat = parseFloat(digitsFloat).toFixed(2).toString();
        return digitsFloat;
    },

    FormatCelular: (value: string) => {

        if (value != null) {
            return "(" + value.substring(0, 2) + ") " + value.substring(2, 3) + " " + value.substring(3, 7) + "-" + value.substring(7);

        }

    },

    FormatTelefone: (value: string) => {

        if (value != null) {
            return "(" + value.substring(0, 2) + ") " + value.substring(2, 2) + " " + value.substring(2, 6) + "-" + value.substring(6);

        }
    },

    FormatParentesco: (value: string) => {

        if (value === 'P') {
            return "Pai"
        }

        if (value === 'F') {
            return "Filho(a)"
        }

        if (value === 'T') {
            return "Tio(a)"
        }

        if (value === 'A') {
            return "Avó / Avô"
        }

        if (value === 'M') {
            return "Mãe"
        }

        if (value === 'O') {
            return "Outros"
        }

    },

    FormatCep: (value: string) => {

        if (value != null) {
            return value.substring(0, 5) + "-" + value.substring(5,8);
        }
    },

    FormatDoc: (value: string) => {

        if (value != null && value.length == 14) {
            return value.substring(0, 2) + "." + value.substring(2,5) + "." + value.substring(5,8) + "/" + value.substring(8, 12) + "-" + value.substring(12, 14)
        }

        if (value != null && value.length == 11) {
            return value.substring(0, 3) + "." + value.substring(3,6) + "." + value.substring(6,9)  + "-" + value.substring(9, 11)
        }

    },

    FormatDataPtBr: (value: string) => {
        if (value === ''){
           return value 
        }

        const ar = value.split('-')

        if (ar.length === 0){
            return value
        }

        return ar[2]+'/'+ar[1]+'/'+ar[0]

    },

    GetDadosEmpresa: (): any => {
        const dadosEmpresa = localStorage.getItem("@ecommerce/dados_empresa");
        if (dadosEmpresa) {
            try {
                return JSON.parse(dadosEmpresa);
            } catch (error) {
                console.error("Erro ao fazer parse dos dados da empresa:", error);
                return null; // Retorna `null` caso ocorra algum problema no JSON.parse
            }
        }
        return null; // Retorna `null` se o item não existir
    },

    ConsultaCEP: async (cep: string): Promise<RetAPI> => {

        const dadosCEP: DadosCEP = {
            cep: "",
            logradouro: "",
            complemento: "",
            bairro: "",
            cidade: "",
            uf: "",
            ibge: 0,
        }

        if ((cep.trim() === "" || cep === undefined) && cep.trim().length !== 8 ){
            return {
                error: true,
                data: dadosCEP
            }
        }

        const xCep = Funcoes.onlyNumber(cep)

        const retAPI: any = await Api(`https://viacep.com.br/ws/${xCep}/json/`, 'get')        
        
        if (retAPI.data.erro){            
           
            return {
                error: true,
                data: dadosCEP
            }

        } else {

            dadosCEP.cep         = cep
            dadosCEP.logradouro  = retAPI.data.logradouro
            dadosCEP.complemento = retAPI.data.complemento
            dadosCEP.bairro      = retAPI.data.bairro
            dadosCEP.cidade      = retAPI.data.localidade
            dadosCEP.uf          = retAPI.data.uf
            dadosCEP.ibge        = parseInt(retAPI.data.ibge)
        }

        return {
            error: false,
            data: dadosCEP
        }

    },

    GetUltDiaMes: (mes: number, ano: number): number => {
        switch (mes){
            case 1:
                return 31
            case 2:
                if (ano % 4 === 0){ // Ano bissexto
                    return 29
                }else{
                    return 28
                }                
            case 3:
                return 31
            case 4:
                return 30
            case 5:
                return 31
            case 6:
                return 30
            case 7:
                return 31
            case 8:
                return 31
            case 9:
                return 30
            case 10:
                return 31
            case 11:
                return 30
            case 12:
                return 31

        }

        return 0
    }
}